import SurveyResponsesSection from './SurveyResponsesSection';

export default SurveyResponsesSection;
